import { styled } from '@material-ui/core/styles';
import Paper from '@material-ui/core/Paper';

const TicketAdvancedLayoutModern = styled(Paper)({
    height: `calc(100% - var(--layout-powered-by-offset, 0px))`,
    display: "flex",
    flexDirection: "column",
    overflow: "hidden",
})

export default TicketAdvancedLayoutModern;

